import { Assets } from './Assets'

export const CSAssets = ({ assets, handleOnClick }) => {
  const checkingAndSavings = (assets || []).filter(
    (option) => option.subType === CSAssets.targetCategory
  )
  return (
    <Assets
      assets={checkingAndSavings}
      handleOnClick={handleOnClick}
      category={CSAssets.targetCategory}
    />
  )
}
CSAssets.targetCategory = 'checkingsavings'
